'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.postPackageIfNeeded = exports.postPackageFailure = exports.postPackageSuccess = exports.postPackageRequest = exports.POST_PACKAGE_FAILURE = exports.POST_PACKAGE_SUCCESS = exports.POST_PACKAGE_REQUEST = undefined;

var _css = require('antd/lib/notification/style/css');

var _notification = require('antd/lib/notification');

var _notification2 = _interopRequireDefault(_notification);

var _css2 = require('antd/lib/message/style/css');

var _message = require('antd/lib/message');

var _message2 = _interopRequireDefault(_message);

var _api = require('../api');

var _order = require('./order');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * 物流、发货相关Actions
 */
var POST_PACKAGE_REQUEST = exports.POST_PACKAGE_REQUEST = 'POST_PACKAGE_REQUEST';
var POST_PACKAGE_SUCCESS = exports.POST_PACKAGE_SUCCESS = 'POST_PACKAGE_SUCCESS';
var POST_PACKAGE_FAILURE = exports.POST_PACKAGE_FAILURE = 'POST_PACKAGE_FAILURE';

var postPackageRequest = exports.postPackageRequest = function postPackageRequest() {
    return {
        type: POST_PACKAGE_REQUEST
    };
};

var postPackageSuccess = exports.postPackageSuccess = function postPackageSuccess(response) {
    return {
        type: POST_PACKAGE_SUCCESS,
        package: response.data
    };
};
var postPackageFailure = exports.postPackageFailure = function postPackageFailure(error) {
    return {
        type: POST_PACKAGE_FAILURE,
        error: error
    };
};

var shouldPostPackage = function shouldPostPackage(state) {
    var packages = state.package.packages;
    if (packages.isPosting) {
        return false;
    }
    return true;
};

var postPackageIfNeeded = exports.postPackageIfNeeded = function postPackageIfNeeded(packageInfo, router) {
    return function (dispatch, getState) {
        if (shouldPostPackage(getState())) {
            return dispatch(function (dispatch) {
                dispatch(postPackageRequest());
                return (0, _api.postPackage)(packageInfo).then(function (response) {
                    _message2.default.success('提交成功');
                    dispatch(postPackageSuccess(response.data));
                    dispatch((0, _order.fetchOrdersIfNeeded)({}, 1));
                }).catch(function (error) {
                    _notification2.default['error']({
                        message: '提交失败',
                        description: error.message + error.response && error.response.data && error.response.data.message
                    });
                    console.error(error);
                    dispatch(postPackageFailure(error));
                });
            });
        }
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/js/actions/package.js
// module id = 908
// module chunks = 0